import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useForm } from 'react-hook-form'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { selectPaymentScheduleData } from '../../../redux/paymentScheduleDataSlice'

export default function CancelRefinanceModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const { handleSubmit, control, formState: { errors }, reset } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const navi = useNavigate()
  const customerId = modal.options?.customerId
  const paymentScheduleData = useSelector(selectPaymentScheduleData);
  const loanId = modal.options?.latest_loan_id

  const onSubmit = async (formData) => {
    setSaving(true)
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/loan/${loanId}/refinance_cancellation`)
    try {
      const response = await request.modify(formData)
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        handleCancel()
        dispatch(setNotification({ type: 'success', body: '' }))
        const pathSegments = window.location.pathname.split('/');
        const moduleName = pathSegments[1];
        setTimeout(() => navi(`/${moduleName}/${customerId}`, { state: { reloadPage: true } }), 2000);
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
    reset();
  };

  return modal.type === 'cancel_refinance_modal' && modal.is_active ? (
    <form onSubmit={handleSubmit(onSubmit)} id="cancel_refinance" className="lox-form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card column is-3" data-testid="cancel-refinance-modal">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              Cancel Refinance
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: "100px", overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column mt-3">
              <div className="column">
                Are you sure you want to cancel this refinance? It will withdraw the refinance lead and restore the old loan.
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
              <button type="submit" className="button is-link is-small" disabled={saving && 'disabled'} data-testid="cancel-refinance-modal-save">{saving ? 'Saving' : 'Save'}</button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
